<template>
	<div class="pd-thin">
		<SectionPageTitle
			title="Posts"
			:actions="auth.state.user._id === route.params._id
				? [{ method: () => router.push({ name: routePrefix + 'CreateBlogPost', params: { _id: route.params._id } }), label: '+', class: 'radius-extra t-white fw-semi i-big hover:scale-[1.05] cursor-pointer t-white bg-second' }]
				: []"
			:tabs="auth.state.user._id === route.params._id
				? [
					{ name: 'My posts', value: 'posts' },
					{ name: 'Drafts', value: 'drafts' },
					{ name: 'Following', value: 'following' },
				]
				: null"
			:tabs_current="tabOrganization"
			@update:tabs_current="tabOrganization = $event"
		/>

		<Feed
			:showLoadMore="false"
			:states="{
				empty: {
					title: 'No Blog Posts Found',
					description: 'Currently, there are no posts available in this blog. Please check back later.'
				},
			}"
			:store="{
				read: (options) => blog.read(options)
			}"
			:options="{
				limit: 15,
				category: route.params.category,
				period: route.query.period,
				status: tabOrganization === 'drafts' ? 'draft' : 'published',
				user: auth.state.user._id,
				creator: ['posts', 'drafts'].includes(tabOrganization) ? route.params._id : null,
				following: tabOrganization === 'following' ? auth.state.user._id : null,
			}"
			v-slot="{ items }"
			class="rows-1 gap-thin"
		>
			<CardBlogpost 
				v-for="item in items" 
				:key="item._id" 
				:blogpost="item" 
				:user="auth.state.user._id" 
				class="h-max-40r bg-light radius-medium"
			/>
		</Feed>
	</div>
</template>

<script setup>
	import { watch, ref, computed } from 'vue'
	import { useRoute, useRouter } from 'vue-router'
	// Components
	import SectionPageTitle from '@martyrs/src/modules/core/views/components/sections/SectionPageTitle.vue'
	import Feed from '@martyrs/src/design-system/components/Feed/Feed.vue'

  import CardBlogpost from '@martyrs/src/modules/community/components/blocks/CardBlogpost.vue';

	import * as auth from '@martyrs/src/modules/auth/views/store/auth.js';
  import * as blog from '@martyrs/src/modules/community/store/blogposts.js';
	// Accessing router
	const route = useRoute()
	const router = useRouter()

	const routePrefix = computed(() => {
		const ctx = route.meta.context
		if (ctx === 'user') return 'User'
		if (ctx === 'organization') return 'Organization'
		if (ctx === 'backoffice') return 'Backoffice'
		return ''
	})

	// State
	let tab = route.query.tab ? route.query.tab : 'posts';

	const tabOrganization = ref(tab)

	route.query.tab = tabOrganization.value

	watch(tabOrganization, (newValue) => {
	  router.replace({ query: { ...route.query, tab: newValue } });
	});
</script>